import React from 'react';
import { Link } from 'react-router-dom';
import './componenetStyle/Sidebar.css';
import Guard from './auth/Guard';

const Sidebar = ( {uzytkownik, navClass, visibilityChange} ) => {
    
   
    return (
        <aside className={navClass}>
            <nav>
                <ul>
                    <li><Link to="/" className='sidenav' onClick={visibilityChange}>Strona główna</Link></li>

                    <Guard permission="page_clients_view">
                        <li><Link to="/klienci" className='sidenav' onClick={visibilityChange}>Klienci</Link></li>
                    </Guard>

                    <Guard permission="page_orders_view">
                        <li><Link to="/zlecenia" className='sidenav' onClick={visibilityChange}>Zlecenia</Link></li>
                    </Guard>

                    <Guard permission="page_employees_view">
                        <li><Link to="/pracownicy" className='sidenav' onClick={visibilityChange}>Pracownicy</Link></li>
                    </Guard>

                    <Guard permission="page_reviews_view">
                        <li><Link to="/przeglady" className='sidenav' onClick={visibilityChange}>Przeglądy</Link></li>
                    </Guard>

                    <Guard permission="page_import_export_view">
                        <li><Link to="/importeksport" className='sidenav' onClick={visibilityChange}>Import/Eksport</Link></li>
                    </Guard>

                    <Guard permission="page_devices_view">
                        <li><Link to="/listaurzadzen" className='sidenav' onClick={visibilityChange}>Lista Urządzeń</Link></li>
                    </Guard>

                    <Guard permission="page_users_view">
                        <li><Link to="/uzytkownicy/dodaj" className='sidenav' onClick={visibilityChange}>Użytkownicy</Link></li>
                    </Guard>

                    <Guard permission="page_warehouse_view">
                        <li><Link to="/towaryUslugi" className='sidenav' onClick={visibilityChange}>Magazyn</Link></li>
                    </Guard>

                    <Guard permission="page_settings_view">
                        <li><Link to="/ustawienia" className='sidenav' onClick={visibilityChange}>Ustawienia</Link></li>
                    </Guard>
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;